import React, { useState, useEffect } from "react";
import { FaTimes, FaSave } from "react-icons/fa";
import BtnGuardar from "../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../components/buttons/BtnCancelar";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function CrearProducto({
  onClose = () => {},
  onCreated = () => {},
}) {
  // --- ESTADOS DE CAMPOS ---
  const [codigo, setCodigo] = useState("");
  const [nombre, setNombre] = useState("");
  const [codigoSap, setCodigoSap] = useState("");
  const [codigoPetropar, setCodigoPetropar] = useState("");
  const [estadoId, setEstadoId] = useState("");
  const [ivaId, setIvaId] = useState("");
  const [rubroId, setRubroId] = useState("");
  const [unidadMedidaId, setUnidadMedidaId] = useState("");

  // Lógica de validación: Verifica que los campos obligatorios no estén vacíos
const isValid = 
    codigo.trim() !== "" && 
    nombre.trim() !== "" && 
    codigoSap.trim() !== "" && // Agregado porque tiene * en el label
    estadoId !== "" && 
    ivaId !== "" && 
    rubroId !== "" && 
    unidadMedidaId !== "";

  // --- ESTADOS DE CATÁLOGOS (COMBOS) ---
  const [listas, setListas] = useState({
    estados: [],
    ivas: [],
    rubros: [],
    unidades: [],
  });

  const [saving, setSaving] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  const [error, setError] = useState("");

  // Cerrar con ESC
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  // Cargar Combos desde Backend al iniciar
  useEffect(() => {
    const cargarCombos = async () => {
     try {
        // Usamos listUrl con un size grande para obtener todos los registros para los combos
        const [resEst, resIva, resRub, resUni] = await Promise.all([
          appFetchJson(apiRoutes.estado.listUrl({ page: 0, size: 200, tipoId:3 })),
          appFetchJson(apiRoutes.ivas.listUrl({ page: 0, size: 200 })),
          appFetchJson(apiRoutes.rubros.listUrl({ page: 0, size: 200 })),
          appFetchJson(apiRoutes.unidadesMedida.listUrl({ page: 0, size: 200 })),
        ]);

        // Extraemos la propiedad .items de cada respuesta
        setListas({
          estados: resEst?.items || [],
          ivas: resIva?.items || [],
          rubros: resRub?.items || [],
          unidades: resUni?.items || [],
        });
        
      } catch (e) {
        console.error("Error cargando combos:", e);
        setError("Error al cargar los catálogos del servidor.");
      } finally {
        setLoadingData(false);
      }
    };
    cargarCombos();
  }, []);

 const guardar = async () => {
    if (!isValid || saving) return; // Esto bloquea la ejecución si falta algo
    setSaving(true);
    try {
      const payload = {
        codigo: codigo.trim(),
        nombre: nombre.trim(),
        codigoSap: codigoSap.trim(),
        codigoPetropar: codigoPetropar.trim(),
        estadoId: Number(estadoId),
        ivaId: Number(ivaId),
        rubroId: Number(rubroId),
        unidadMedidaId: Number(unidadMedidaId),
        // Precios por defecto en 0 para evitar nulos en backend
        precioPorton: 0,
        precioCompra: 0,
        margenPetropar: 0
      };

      const created = await appFetchJson(apiRoutes.productos.create, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload),
      });

      onCreated(created);
      onClose();
    } catch (e) {
      console.error("Error creando producto:", e);
      setError(e?.message || "Ocurrió un error al guardar el producto.");
    } finally {
      setSaving(false);
    }
  };

  if (loadingData) return null;

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel-lg" onClick={(e) => e.stopPropagation()}>
        {/* HEADER */}
        <div className="modal-header flex justify-between items-center">
          <h2 className="section-title">Crear Producto</h2>
          <button className="modal-close-x" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        {/* BODY */}
        <div className="modal-body">
          <p className="text-gray-600 mb-4 italic">Introduzca los datos de Producto</p>
          
          {error && <div className="text-red-600 mb-3 font-medium">{error}</div>}

          <div className="form-grid">
            {/* COD. PRODUCTO */}
            <div className="form-row">
              <label className="form-label">Cód. Producto *</label>
              <input
                type="text"
                className="input"
                value={codigo}
                onChange={(e) => setCodigo(e.target.value)}
              />
            </div>

            {/* DESCRIPCIÓN */}
            <div className="form-row">
              <label className="form-label">Descripción *</label>
              <input
                type="text"
                className="input"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
              />
            </div>

            {/* COD. SAP */}
            <div className="form-row">
              <label className="form-label">Cod. Sap *</label>
              <input
                type="text"
                className="input"
                value={codigoSap}
                onChange={(e) => setCodigoSap(e.target.value)}
              />
            </div>

            {/* ESTADO */}
            <div className="form-row">
              <label className="form-label">Estado *</label>
              <select 
                className="input" 
                value={estadoId} 
                onChange={(e) => setEstadoId(e.target.value)}
              >
                <option value="">--- Seleccione ---</option>
                {listas.estados.map(opt => (
                  <option key={opt.id} value={opt.id}>{opt.nombre}</option>
                ))}
              </select>
            </div>

            {/* IVA */}
            <div className="form-row">
              <label className="form-label">Iva *</label>
              <select 
                className="input" 
                value={ivaId} 
                onChange={(e) => setIvaId(e.target.value)}
              >
                <option value="">--- Seleccione ---</option>
                {listas.ivas.map(opt => (
                  <option key={opt.id} value={opt.id}>{opt.nombre}</option>
                ))}
              </select>
            </div>

            {/* RUBRO */}
            <div className="form-row">
              <label className="form-label">Rubro *</label>
              <select 
                className="input" 
                value={rubroId} 
                onChange={(e) => setRubroId(e.target.value)}
              >
                <option value="">--- Seleccione ---</option>
                {listas.rubros.map(opt => (
                  <option key={opt.id} value={opt.id}>{opt.nombre}</option>
                ))}
              </select>
            </div>

            {/* UNIDAD DE MEDIDA */}
            <div className="form-row">
              <label className="form-label">Unidad de Medida *</label>
              <select 
                className="input" 
                value={unidadMedidaId} 
                onChange={(e) => setUnidadMedidaId(e.target.value)}
              >
                <option value="">--- Seleccione ---</option>
                {listas.unidades.map(opt => (
                  <option key={opt.id} value={opt.id}>{opt.nombre}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* FOOTER */}
      <div className="modal-footer">
          <div className="btn-row">
            <BtnGuardar 
              label="Guardar"
              isValid={isValid} 
              saving={saving} 
              onClick={guardar} 
            />
            <BtnCancelar onClick={onClose} />
          </div>
        </div>
      </div>
    </div>
  );
}